export default function GradientDiv({height = "5px"}) {
    return (
        <div className="gradient-loader w-full" style={{height}}/>
    );
};
